"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_NIGHTLY_PRICE = void 0;
exports.MAX_NIGHTLY_PRICE = 50000; // Max. price according to B.com
//# sourceMappingURL=constants.js.map